(() => {
  const toggle = document.querySelector('.menu-toggle');
  const nav = document.querySelector('.primary-nav');
  if (toggle && nav) {
    toggle.addEventListener('click', () => {
      const open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      nav.classList.toggle('is-open', !open);
      document.body.classList.toggle('menu-open', !open);
    });
    nav.addEventListener('click', (event) => {
      if (!event.target.closest('a')) return;
      toggle.setAttribute('aria-expanded', 'false');
      nav.classList.remove('is-open');
      document.body.classList.remove('menu-open');
    });
  }

  const slider = document.querySelector('[data-hero-slider]');
  if (slider) {
    const slides = [...slider.querySelectorAll('.hero-slide')];
    const heroCopy = document.querySelector('[data-hero-copy]');
    const kicker = heroCopy?.querySelector('[data-hero-kicker]');
    const lineOne = heroCopy?.querySelector('[data-hero-line-one]');
    const lineTwo = heroCopy?.querySelector('[data-hero-line-two]');
    const heroLink = heroCopy?.querySelector('[data-hero-link]');
    const heroCta = heroCopy?.querySelector('[data-hero-cta]');
    const messages = [...document.querySelectorAll('[data-hero-message]')];
    const currentLabel = slider.querySelector('[data-slide-current]');
    const brandLabel = slider.querySelector('[data-slide-brand]');
    const previous = slider.querySelector('[data-slide-prev]');
    const next = slider.querySelector('[data-slide-next]');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let current = 0;
    let messageCurrent = 0;
    let timer;
    let messageTimer;

    const showSlide = (index) => {
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === current;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
      });
      const activeSlide = slides[current];
      currentLabel.textContent = String(current + 1).padStart(2, '0');
      brandLabel.textContent = activeSlide.dataset.brand || 'LLITIO';
    };

    const showMessage = (index) => {
      if (!messages.length || !heroCopy || !kicker || !lineOne || !lineTwo || !heroLink || !heroCta) return;
      messageCurrent = (index + messages.length) % messages.length;
      const message = messages[messageCurrent];
      heroCopy.classList.remove('is-animating');
      heroCopy.dataset.motion = message.dataset.motion || 'rise';
      kicker.textContent = message.dataset.kicker || 'LLITIO';
      lineOne.textContent = message.dataset.lineOne || '';
      lineTwo.textContent = message.dataset.lineTwo || '';
      heroLink.href = message.dataset.link || '/pages/lookbook';
      heroCta.textContent = message.dataset.cta || 'OPEN THE LOOKBOOK';
      void heroCopy.offsetWidth;
      heroCopy.classList.add('is-animating');
    };

    const stop = () => {
      window.clearInterval(timer);
      window.clearInterval(messageTimer);
    };
    const start = () => {
      stop();
      if (!reduceMotion) {
        timer = window.setInterval(() => showSlide(current + 1), 4600);
        messageTimer = window.setInterval(() => showMessage(messageCurrent + 1), 7200);
      }
    };

    previous.addEventListener('click', () => { showSlide(current - 1); start(); });
    next.addEventListener('click', () => { showSlide(current + 1); start(); });
    slider.addEventListener('pointerenter', stop);
    slider.addEventListener('pointerleave', start);
    slider.addEventListener('focusin', stop);
    slider.addEventListener('focusout', start);
    showSlide(0);
    showMessage(0);
    start();
  }

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const revealTargets = [...document.querySelectorAll('.brand-header, .lookbook-story, .brand-story__products > header, .lookbook-cta__copy')];
  revealTargets.forEach((target, index) => {
    target.classList.add('reveal-block');
    target.dataset.reveal = String((index % 4) + 1);
  });
  if (reduceMotion || !('IntersectionObserver' in window)) {
    revealTargets.forEach((target) => target.classList.add('is-visible'));
  } else {
    const revealObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.18 });
    revealTargets.forEach((target) => revealObserver.observe(target));
  }

  const lookbookPage = document.querySelector('[data-lookbook-page]');
  const lookbookPanels = [...document.querySelectorAll('[data-lookbook-panel]')];
  if (lookbookPanels.length) {
    if (reduceMotion || !('IntersectionObserver' in window)) {
      lookbookPanels.forEach((panel) => panel.classList.add('is-current'));
    } else {
      const lookbookObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add('is-current');
        });
      }, { root: lookbookPage, threshold: 0.42 });
      lookbookPanels.forEach((panel) => lookbookObserver.observe(panel));
    }
  }

  const productRoot = document.querySelector('[data-product-root]');
  const productForm = productRoot?.querySelector('[data-product-form]');
  if (productRoot && productForm) {
    const variantInput = productForm.querySelector('[data-variant-id]');
    const variantScript = productForm.querySelector('[data-product-variants]');
    const optionGroups = [...productForm.querySelectorAll('.product-option[data-option-index]')];
    const optionInputs = [...productForm.querySelectorAll('[data-product-option]')];
    const price = productRoot.querySelector('[data-product-price]');
    const addButton = productForm.querySelector('[data-add-to-cart]');
    const quantityInput = productForm.querySelector('input[name="quantity"]');
    const minus = productForm.querySelector('[data-quantity-minus]');
    const plus = productForm.querySelector('[data-quantity-plus]');
    const galleryThumbs = [...productRoot.querySelectorAll('[data-media-thumb]')];
    const galleryItems = [...productRoot.querySelectorAll('[data-media-item]')];
    let activeGalleryColor = productRoot.dataset.selectedColor || '';
    let variants = [];

    try {
      variants = JSON.parse(variantScript?.textContent || '[]');
    } catch (error) {
      variants = [];
    }

    const formatMoney = (amount) => {
      const currency = productRoot.dataset.currency || 'USD';
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      }).format(amount / 100);
    };

    const colorKey = (value) => value.toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');

    const showGalleryMedia = (mediaId) => {
      galleryItems.forEach((item) => {
        const active = item.dataset.mediaId === mediaId;
        item.hidden = !active;
        item.classList.toggle('is-active', active);
      });
      galleryThumbs.forEach((thumb) => {
        const active = thumb.dataset.mediaId === mediaId;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-pressed', String(active));
      });
    };

    const updateGalleryColor = (color) => {
      const nextColor = colorKey(color || '');
      galleryThumbs.forEach((thumb) => {
        thumb.hidden = Boolean(nextColor && thumb.dataset.mediaColor && thumb.dataset.mediaColor !== nextColor);
      });
      const currentThumb = galleryThumbs.find((thumb) => thumb.classList.contains('is-active'));
      const firstVisibleThumb = galleryThumbs.find((thumb) => !thumb.hidden);
      if (nextColor !== activeGalleryColor || !currentThumb || currentThumb.hidden) {
        if (firstVisibleThumb) showGalleryMedia(firstVisibleThumb.dataset.mediaId);
      }
      activeGalleryColor = nextColor;
    };

    galleryThumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => showGalleryMedia(thumb.dataset.mediaId));
    });
    updateGalleryColor(activeGalleryColor);

    const updateVariant = () => {
      if (!optionGroups.length || !variants.length) return;
      const selectedOptions = optionGroups.map((group) => group.querySelector('[data-product-option]:checked')?.value || '');
      const variant = variants.find((item) => item.options.every((value, index) => value === selectedOptions[index]));
      const selectedColor = productForm.querySelector('.product-option--color [data-product-option]:checked')?.value || '';

      variantInput.value = variant?.id || '';
      addButton.disabled = !variant?.available;
      addButton.textContent = variant?.available ? 'ADD TO CART' : 'SOLD OUT';
      if (variant && price) price.textContent = formatMoney(variant.price);
      updateGalleryColor(selectedColor);

      if (variant) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }
    };

    optionInputs.forEach((input) => input.addEventListener('change', updateVariant));
    minus?.addEventListener('click', () => {
      quantityInput.value = String(Math.max(1, Number.parseInt(quantityInput.value, 10) - 1 || 1));
    });
    plus?.addEventListener('click', () => {
      quantityInput.value = String(Math.max(1, Number.parseInt(quantityInput.value, 10) + 1 || 1));
    });
    quantityInput?.addEventListener('change', () => {
      quantityInput.value = String(Math.max(1, Number.parseInt(quantityInput.value, 10) || 1));
    });
  }

  const modal = document.querySelector('[data-demo-modal]');
  if (!modal) return;
  const gallery = modal.querySelector('[data-demo-gallery]');
  const title = modal.querySelector('[data-demo-title]');
  const price = modal.querySelector('[data-demo-price]');
  const brand = modal.querySelector('[data-demo-brand]');
  const demoSize = modal.querySelector('[data-demo-size]');
  const demoAdd = modal.querySelector('[data-demo-add]');

  document.querySelectorAll('.demo-trigger').forEach((trigger) => {
    trigger.addEventListener('click', () => {
      title.textContent = trigger.dataset.demoTitle || '';
      price.textContent = trigger.dataset.demoPrice || '';
      brand.textContent = trigger.dataset.demoBrand || '';
      if (demoSize) demoSize.value = 'Small';
      if (demoAdd) demoAdd.textContent = 'ADD TO CART';
      gallery.replaceChildren();
      (trigger.dataset.demoImages || '').split(',').filter(Boolean).forEach((source, index) => {
        const image = document.createElement('img');
        image.src = source;
        image.alt = `${trigger.dataset.demoTitle} ${index === 0 ? 'flat garment' : `lookbook ${index}`}`;
        gallery.appendChild(image);
      });
      modal.showModal();
      document.body.classList.add('modal-open');
    });
  });

  const closeModal = () => {
    modal.close();
    document.body.classList.remove('modal-open');
  };
  modal.querySelector('.demo-modal__close').addEventListener('click', closeModal);
  modal.addEventListener('click', (event) => {
    if (event.target === modal) closeModal();
  });
  modal.addEventListener('close', () => document.body.classList.remove('modal-open'));
  if (demoAdd && demoSize) {
    demoAdd.addEventListener('click', () => {
      demoAdd.textContent = `ADDED — ${demoSize.value.toUpperCase()}`;
    });
  }
})();
